import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DashboardComponent } from './features/components/dashboard/dashboard.component';
import { isLoggedIn } from './core/guards/is-logged-in.guard';
import { AirwayBillPrintComponent } from './shared/components/airway-bill-print/airway-bill-print.component';

const routes: Routes = [
  {
    path: '',
    canActivate: [],
    component: DashboardComponent,
    data: { breadcrumb: { alias: 'home' } },
  },
  {
    path: 'contact-sales',
    canActivate: [],
    loadChildren: () =>
      import('./features/components/contact-sales/contact-sales.module').then(
        m => m.ContactSalesModule
      ),
    data: { breadcrumb: { alias: 'contactsales' } },
  },
  {
    path: 'shipment-tracking',
    canActivate: [],
    loadChildren: () =>
      import(
        './features/components/shipment-tracker/shipment-tracker.module'
      ).then(m => m.ShipmentTrackerModule),
    data: { breadcrumb: { alias: 'shipment-tracking' } },
  },
  {
    path: 'track-manifest',
    canActivate: [isLoggedIn],
    loadChildren: () =>
      import(
        './features/components/manifest-tracker/manifest-tracker.module'
      ).then(module => module.ManifestTrackerModule),
    data: { breadcrumb: { alias: 'track-manifest' } },
  },
  {
    path: 'manifest-upload',
    canActivate: [isLoggedIn],
    loadChildren: () =>
      import(
        './features/components/manifest-upload/manifest-upload.module'
      ).then(module => module.ManifestUploadModule),
    data: { breadcrumb: { alias: 'manifest-upload' } },
  },
  {
    path: 'aams-documents',
    canActivate: [],
    loadChildren: () =>
      import('./features/components/aams-documents/aams-documents.module').then(
        module => module.AamsDocumentsModule
      ),
    data: { breadcrumb: { alias: 'aams-documents' } },
  },
  {
    path: 'air-waybill',
    canActivate: [isLoggedIn],
    loadChildren: () =>
      import('./features/components/air-waybill/air-waybill.module').then(
        module => module.AirWaybillModule
      ),
    data: { breadcrumb: { alias: 'air-waybill' } },
  },
  {
    path: 'airway-bill-print-preview',
    canActivate: [isLoggedIn],
    component: AirwayBillPrintComponent,
  },
  {
    path: 'api-documentation',
    canActivate: [],
    loadChildren: () =>
      import('./features/components/api-documentation/api-documentation.module').then(
        module => module.ApiDocumentationModule
      ),
    data: { breadcrumb: { alias: 'api-documentation' } },
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
